'use strict';
import {Component, Inject, Input} from 'ng-metadata/core';
import {PushtoService} from '../pushto.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service'
import {isBrowserSafari, isIosDevice} from '../../../infra/browserSniffer';
const get = require('lodash/get');



@Component({
    selector: 'prm-export-ris',
    templateUrl: 'components/search/actions/exportRISAction/export-ris.html'
})


export class PrmExportRis{
    @Input() private item: Object;
    @Input() public selectedIds: Object;
    private encodingVal:string;
    private popupWin : Window;
    private _risErrorMessage;
    private RIS_RECORD_END_STRING:string = 'ER  -';


    private encodingList: string[];

    constructor(private pushtoService: PushtoService,
                private mtCache:MappingTablesCache,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$document') private $document){
        this.setEncodingValues();
    }

    getFile() {
        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let params = {};
        if (this.encodingVal) {
            params.encoding = this.encodingVal;
        }
        let pushtoPromise = this.pushtoService.getServiceUrl([this.item], this.selectedIds, 'exportris',params);
        pushtoPromise.then((response)=>successAction(response, this.selectedIds), (response)=>failedAction(response));
    }

    get encoding() {
        return this.encodingList;
    }

    setEncodingValues() {
        let rows = this.mtCache.getTable(this.mtCache.tables.EXPORT_RIS_ENCODINGS);


        if (rows.length> 0){
            this.encodingList = rows.map((r)=>{return r.source1;});
        }
    }

    private successfullPushtoAction(response, selectedIds) {
        if(selectedIds){ // on loans tab
            this._risErrorMessage = this.evalRisErrorMessage(response, selectedIds);
            if(this._risErrorMessage === 'loans.invalid'){
                return; // prevent the RIS file downloading when it is empty
            }
        }
        let enc = this.encodingVal || 'UTF-8';
        let blob = new Blob([response.data.data], {endings: 'native', type: 'text/plain;charset=' + enc});
        let filename = 'Primo_RIS_Export.ris';
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            window.navigator.msSaveBlob(blob, filename);
        }else {
            let url = window.URL.createObjectURL(blob);
            let e = document.createEvent('MouseEvents');
            let a = document.createElement('a');

            try {
                a.download = filename;
                a.href = url;
                a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
            } catch (err) {console.log(err);}
            try {
                if (isIosDevice() && this._risErrorMessage !== 'loans.invalid') {
                    this.popupWin = window.open(url,'ris');
                }
                else {
                    e.initEvent('click', true, false);
                    a.dispatchEvent(e);
                }
                
            } catch (err) {}

            this.$timeout(function () {
                window.URL.revokeObjectURL(url);
            }, 600);
        }


    }

    private get risErrorMessage() {
        return this._risErrorMessage;
    }

    private evalRisErrorMessage(response, selectedIds) {
        let evalRisErrorMessage = '';
        let responseFile = get(response,'data.data');
        let risFileRecordcount = responseFile ? (responseFile.match(new RegExp(this.RIS_RECORD_END_STRING, "gi")) || []).length : 0 ;
        if(risFileRecordcount === 0){
            return 'loans.invalid';
        }
        return risFileRecordcount === selectedIds.length ? '' : 'loans.someInvalid';
    }

    private failedPushtoAction(response) {

    }
}







// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/exportRISAction/exportRis.directive.ts